(() => {
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.getElementById('CartDrawer');
  let lastFocus;
  document.querySelectorAll('[data-product-addons]').forEach(group => { group.hidden = false; });
  const closeDrawer = () => { drawer?.close(); lastFocus?.focus(); };
  document.addEventListener('click', async event => {
    const previewTrigger = event.target.closest('[data-addon-preview]');
    if (previewTrigger && (previewTrigger.type !== 'checkbox' || previewTrigger.checked)) {
      const imageDialog = document.getElementById(previewTrigger.dataset.addonPreview);
      if (imageDialog && typeof imageDialog.showModal === 'function' && !imageDialog.open) imageDialog.showModal();
    }
    const previewClose = event.target.closest('[data-addon-close]');
    if (previewClose) previewClose.closest('dialog')?.close();
    if (event.target.matches('.avaro-addon-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
    const slideButton = event.target.closest('[data-slide-to]');
    if (slideButton) {
      const hero = slideButton.closest('[data-hero]');
      hero.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== slideButton.dataset.slideTo; });
      hero.querySelectorAll('[data-slide-to]').forEach(button => button.setAttribute('aria-pressed', String(button === slideButton)));
    }
    if (event.target.closest('[data-close]')) closeDrawer();
    const trigger = event.target.closest('[data-open-cart]');
    if (trigger && drawer && typeof drawer.showModal === 'function') {
      event.preventDefault();
      lastFocus = trigger;
      try { await refreshCart(); drawer.showModal(); } catch { window.location.href = trigger.href; }
    }
  });
  drawer?.addEventListener('click', event => { if (event.target === drawer && event.clientX < drawer.getBoundingClientRect().left) closeDrawer(); });
  drawer?.addEventListener('cancel', () => { lastFocus?.focus(); });
  async function refreshCart() {
    const response = await fetch(`${root}?sections=cart-content`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const sections = await response.json();
    if (!sections['cart-content']) throw new Error('Cart unavailable');
    drawer.querySelector('[data-cart-content]').innerHTML = sections['cart-content'];
    const cartResponse = await fetch(`${root}cart.js`);
    if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; }); }
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const section = select.closest('[data-product-section]');
    const button = section.querySelector('[name="add"]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
    const quantity = section.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1'; quantity.value = quantity.min;
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    const price = section.querySelector('[data-product-price]');
    price.textContent = option.dataset.price;
    if (option.dataset.compare) { const strike = document.createElement('s'); strike.textContent = option.dataset.compare; price.append(' ', strike); }
    const nextUrl = new URL(window.location.href); nextUrl.searchParams.set('variant', option.value); history.replaceState({}, '', nextUrl);
    const media = section.querySelector(`#Media-${option.dataset.media}`);
    if (media) { const gallery = media.parentElement; if (window.matchMedia('(max-width:750px)').matches) gallery.scrollTo({left: media.offsetLeft - gallery.offsetLeft, behavior: 'instant'}); else gallery.prepend(media); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    const hasDrawer = drawer && typeof drawer.showModal === 'function';
    const selectedAddons = [...form.querySelectorAll('[data-addon-variant]:checked')];
    if (!hasDrawer && !selectedAddons.length) return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    const error = form.querySelector('.form-error');
    button.disabled = true; button.setAttribute('aria-busy', 'true'); error.textContent = '';
    let added = false;
    try {
      const body = new FormData(form);
      if (selectedAddons.length) {
        const lineFields = [...body.entries()].filter(([key]) => key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties['));
        lineFields.forEach(([key, value]) => {
          body.delete(key);
          const indexedKey = key.startsWith('properties[') ? 'items[0][properties]' + key.slice(10) : 'items[0][' + key + ']';
          body.append(indexedKey, value);
        });
        selectedAddons.forEach((input, index) => {
          body.append('items[' + (index + 1) + '][id]', input.dataset.addonVariant);
          body.append('items[' + (index + 1) + '][quantity]', '1');
        });
      }
      const response = await fetch(`${root}cart/add.js`, {method: 'POST', body, headers: {Accept: 'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      added = true;
      if (!hasDrawer) { window.location.assign(`${root}cart`); return; }
      await refreshCart(); lastFocus = button; drawer.showModal();
    } catch (err) {
      if (added) window.location.assign(`${root}cart`);
      else error.textContent = err.message || 'Please try again.';
    } finally { button.disabled = false; button.removeAttribute('aria-busy'); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); }); });
})();
